<template>
  <v-row class="elevation-3 mb-2 pa-2" style="border-radius: 4px">
    <v-col cols="12" class="d-flex ma-0 pa-0 justify-center my-2">
      <span style="font-size: 18px" class="red--text">
        Dia: {{ getFormatedDate(swap.date) }}
      </span></v-col
    >
    <v-col
      cols="12"
      md="4"
      lg="4"
      class="d-flex justify-space-between flex-column pa-2"
      style="border: solid 1px #a7a7a7; border-radius: 4px"
    >
      <p class="ma-0">De: {{ swap.from }}</p>
      <!-- <p class="ma-0">Dia: {{ getFormatedDate(swap.date) }}</p> -->
      <div class="blue pa-2 white--text" style="border-radius: 4px">
        <span style="font-size: 16px; font-weight: bold">Escala</span><br />
        <span class="ma-0" style="font-size: 12px">Tipo: {{ swap.scale_type_from.name }}</span
        ><br />
        <span class="ma-0" style="font-size: 12px"
          >Carga horária: {{ swap.scale_type_from.workload }}h</span
        >
      </div>
    </v-col>
    <v-col cols="12" md="1" lg="1" class="d-flex justify-center">
      <v-icon>mdi-swap-horizontal</v-icon>
    </v-col>

    <v-col
      cols="12"
      md="4"
      lg="4"
      class="d-flex justify-space-between flex-column"
      style="border: solid 1px #a7a7a7; border-radius: 4px"
    >
      <p class="ma-0">Para: {{ swap.to }}</p>
      <!-- <p class="ma-0">Dia: {{ getFormatedDate(swap.date) }}</p> -->
      <template v-if="employeeFromData.workload > 0">
        <div class="blue pa-2 white--text" style="border-radius: 4px">
          <span style="font-size: 16px; font-weight: bold">Escala</span><br />
          <span class="ma-0" style="font-size: 12px">Tipo: {{ employeeFromData.type }}</span
          ><br />
          <span class="ma-0" style="font-size: 12px"
            >Carga horária: {{ employeeFromData.workload }}h</span
          >
        </div>
      </template>
      <template v-else>
        <div
          class="d-flex justify-center green align-center white--text"
          style="border-radius: 4px"
        >
          <span class="">Disponível</span>
        </div>
      </template>
    </v-col>
    <v-col cols="12" lg="3" md="3" sm="3" class="d-flex justify-end">
      <div class="buttons-container">
        <v-btn color="grey" dark class="mb-2" @click="updateSwap(false, swap)">Recusar</v-btn>
        <v-btn color="green" dark @click="updateSwap(true, swap)">Aceitar</v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { formatDateToShow } from '@/global/functions'
import { mapActions } from 'vuex'
export default {
  name: 'ScaleSwapCard',
  props: {
    swap: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data: () => {
    return {}
  },
  computed: {
    employeeFromData() {
      const data = { workload: 0, type: '' }
      this.swap.scale_type_to
        ? this.swap.scale_type_to.map((scale_type, index) => {
            data.workload += scale_type.workload
            data.type +=
              scale_type.scale_type + (index == this.swap.scale_type_to.length - 1 ? '.' : ', ')
          })
        : null
      return data
    },
  },
  methods: {
    ...mapActions('coordinator', ['ActionApproveSwap']),
    getFormatedDate(date) {
      return formatDateToShow(date).split(' ')[0]
    },
    async updateSwap(value, swap) {
      try {
        await this.$swal({
          icon: 'warning',
          title: 'Atenção',
          showCancelButton: true,
          text: `Você realmente deseja ${value ? 'aceitar' : 'recusar'} a solicitação?`,
        }).then(async (response) => {
          if (response.isConfirmed) {
            const payload = { ...swap, employee_approval: value }
            await this.ActionApproveSwap({ swap, coordinator_approval: value })
            this.$swal({
              icon: 'success',
              title: 'Respondido',
              html: `Solicitação respondida com sucesso.`,
            })
          }
        })
      } catch (e) {}
    },
  },
}
</script>

<style>
.buttons-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

@media (min-width: 320px) and (max-width: 1053px) {
  .buttons-container {
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }
}
</style>
